export default __webpack_public_path__ + "static/media/coin_usdc.d1ade453.svg";